import { ActionTree } from 'vuex';

import pollsApi from '@/api/polls';

// Типы данных для состояния
export interface IPoll {
  Id: number;
  Title: string;
  IsReaded: boolean;
  // Добавь остальные поля из API при необходимости
}

export interface IPollResult {
  QuestionId: number;
  Answer: string;
  // Добавь остальные поля при необходимости
}

export interface IPollState {
  poll: IPoll | null;
  pollResults: IPollResult[] | null;
}

export default {
  actions: <ActionTree<IPollState, any>>{
    async saveResult(_: unknown, payload: IPollState): Promise<any> {
      const response = await pollsApi.saveResult(payload);
      return response;
    },

    async setReadedFlag(_: unknown, id: string): Promise<any> {
      const response = await pollsApi.setReadedFlag(id);
      return response;
    },

    async results(_: unknown, id: string): Promise<any> {
      const response = await pollsApi.results(id);
      return response;
    },
  },
};